namespace GeniuzPOS.QRreport {
    export enum ItemPriceFg {
        netsales = 0,
        baseprice = 1,
        basepriceunit = 2
    }
    Serenity.Decorators.registerEnumType(ItemPriceFg, 'GeniuzPOS.QRreport.ItemPriceFg');
}
